import { render, staticRenderFns } from "./CooperativeColleges.vue?vue&type=template&id=0114b24a&scoped=true&"
import script from "./CooperativeColleges.vue?vue&type=script&lang=js&"
export * from "./CooperativeColleges.vue?vue&type=script&lang=js&"
import style0 from "./CooperativeColleges.vue?vue&type=style&index=0&id=0114b24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0114b24a",
  null
  
)

export default component.exports